import { Component, Injector, Input } from '@angular/core';
import { Events } from 'ionic-angular';
import { EthemeProvider } from '../../providers/etheme/etheme';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'linesvg_percorso', 
  templateUrl: 'linesvg_percorso.html',
}) 

export class LineSvgPercorsoComponent{

  // @Input('percent') percent:number; 
  _precent;
  @Input()
  set percent(value: any) {

    if(value == undefined || value == null || value == ''){
      this.percentuale = 1;
      return;
    }
    if(value == 0 || value == '0'){
      this.percentuale = 1;
      return;
    }
    if(value < 1)
     this.percentuale = 1;
    else
     this.percentuale = 620/100*value; 
    // this._precent = value;
    // this.percentuale = 265 - (265 / 100 * this._precent);
    // console.log(value);
  }

  get percent() {  
    return this.percentuale;
  }
  /*@Input('width') width:number; */
  @Input('startcolor') startcolor:string; 
  @Input('endcolor') endcolor:string; 
  @Input('colortext') colortext:string;
  percentuale:any;
  lunghezza:any;
  crand:any;
  constructor(public events: Events, public injector: Injector, public etheme: EthemeProvider) {
  }
  update_output(){
  //  this.events.publish('aperta', this.domanda, this.risp);
  }
  ngOnInit(){
    //var l = this.width/100 * this.percent;
    // this.lunghezza = "M10,10L"+this.width+",10";
    // this.percentuale = "M10,10L"+l+",11";
    //////////this.lunghezza = "M10,10L"+this.width+",10"; 
    this.crand = this.guid();
    // this.lunghezza = "M10,0L12,0";
    //this.percentuale = "M10,0L"+l+",0";
    //d="M1,0L99,0"
    if(this.percent < 1)
      this.percentuale = 1;
    // else
    //   this.percentuale = 620/100*this.percent;
  }
  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  guid() {
  return this.s4() + this.s4() + this.s4()  + this.s4();
  }
}



// WEBPACK FOOTER //
// ./src/pages/component/linesvg_percorso.ts